import { Float, Position, Size } from '../find-postion-env';

const findLeft = (
  containerRect: DOMRect | undefined,
  float: Float,
  size: Size,
  triggerPosition: Position,
) => {
  let left = 0;

  if (float == 'left') {
    if (window.innerWidth - triggerPosition.left < size.width) {
      left = window.innerWidth - size.width - 8;
    } else {
      left = triggerPosition.left;
    }
  } else {
    if (window.innerWidth - (triggerPosition.left - size.width) < size.width) {
      left = size.width + 8;
    } else {
      left = triggerPosition.left - size.width;
    }
  }

  if (!containerRect) return left;
  left -= containerRect.x;

  return left;
};

export default findLeft;
